import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material';
import { JE_TABLE_CLASSES } from 'components/Tables/grid/StyledComponents';

export const SummaryTableLayout = styled('div', {
  label: 'SummaryTableLayout',
})(({ theme }) => ({
  marginTop: 20,
  marginLeft: 30,
  position: 'relative',
  marginBottom: 60, // this allow summary to be scrolled to bottom

  border: '1px solid #F0F0F0',
  borderTop: `2px solid ${theme.palette.primary.main}`,
  paddingTop: 15,
  paddingBottom: 15,
  paddingLeft: 20,
  paddingRight: 20,
  borderRadius: 4,
  backgroundColor: alpha(theme.palette.primary.main, 0.02),
}));

export const JETableOverride = styled('div', {
  label: 'JETableOverride',
})(({ theme }) => ({
  [`& .${JE_TABLE_CLASSES.COLGROUP_COL}`]: {
    width: '25%',
  },

  [`& .${JE_TABLE_CLASSES.ROW}`]: {
    backgroundColor: 'transparent',

    [`&:last-child .${JE_TABLE_CLASSES.CELL}:after`]: {
      display: 'none',
    },
  },

  [`& .${JE_TABLE_CLASSES.CELL}`]: {
    '& [data-element="je.fakeCell.value"]': {
      borderBottom: '1px solid #DEE2E6',
      paddingLeft: 0,
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      display: 'block',
      top: '100%',
      left: 0,
      right: 0,
      borderBottom: '1px solid #DEE2E6',
    },
    '&:nth-child(2)': {
      textAlign: 'right',
      paddingRight: 10,
      '&:after': {
        right: 10,
      },
    },
    '&:nth-child(4)': {
      textAlign: 'right',
    },
  },

  [`& .${JE_TABLE_CLASSES.CELL_MANDATORY}`]: {
    '& [data-element="je.fakeCell.value"]': {
      borderBottomColor: theme.palette.error.main,
    },
  },

  [`& .${JE_TABLE_CLASSES.CELL_ACTIVE}`]: {
    '& [data-element="je.fakeCell.value"], & [data-element="je.autocomplete.field"]': {
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    '& [data-element="je.hintinput.field"], & [data-element="je.literal.field"] ': {
      borderBottom: `2px solid ${theme.palette.primary.main}`,
      padding: 0,
    },
  },
}));
